import React, { useState, useEffect } from 'react';
import { eventTracker } from "../../services/eventTracker";
import { toast } from 'react-toastify';
import styled, { keyframes, css } from 'styled-components';
import {getCreateMudrexUserInfo,
        getConversionRate,
        sendOffRampRequest
} from '../../services/backendHelpers';
import back from '../../styles/assets/back_arrow.svg';
import blue_tick from '../../styles/assets/blue_tick.svg';
import right_arrow from '../../styles/assets/right_arrow.svg';
import withdraw_blue from '../../styles/assets/withdraw_blue.svg';
import bank_blue from '../../styles/assets/bank_blue.svg';
import glip_icon_blue from '../../styles/assets/glip_icon_blue.svg';
import { removeSubscribeBack, subscribeBack } from '../../services/androidCallback';
import { useLocation, useNavigate } from "react-router-dom";

const rotate = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`;

const BackTitle = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 24px;
    color: #FFFFFF;
`;

const PageWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
`;

const StyledLoader = styled.div`
    display: inline-block;
    width: 80px;
    height: 80px;

    &:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid;
    border-color: #3498db transparent #3498db transparent;
    animation: ${rotate} 1.2s linear infinite;
    }
`;

const Loader: React.FC = () => {
    return <StyledLoader />;
};



interface BankAccount {
    id: number;
    name: string;
}

// Styled components
const Container = styled.div`
    display: flex;
    
    height: 100vh;
    flex-direction: column;
    padding: 16px;
    background: rgba(14, 15, 24, 1);
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: space-between;
`;


const FlexContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    justify-content: center;
    align-items: center;
    height: 100%;
    padding: 16px;
`;

const Box = styled.div`
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    padding: 1rem;
    background-color: #1c1c1c;
    border-radius: 4px;
`;

const StyledButton = styled.button`
    background-color: #4caf50;
    color: white;
    font-size: 1rem;
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    &:disabled {
    background-color: #888;
    cursor: not-allowed;
    }
    &:hover:not(:disabled) {
    background-color: #45a049;
    }
`;

const SmallButton = styled(StyledButton)`
  padding: 0.25rem 0.5rem;
  font-size: 0.8rem;
`;

const StyledInput = styled.input`
    background-color: #333;
    color: white;
    padding: 0.5rem;
    font-size: 1rem;
    border: none;
    border-radius: 4px;
`;

const StyledSelect = styled.select`
    background-color: #333;
    color: white;
    padding: 0.5rem;
    font-size: 1rem;
    border: none;
    border-radius: 4px;
`;

const AccountList = styled.ul`
    list-style: none;
    padding: 0;
    margin: 0;
`;

const AccountListItem = styled.li`
    padding: 0.5rem;
    background-color: #333;
    color: white;
    border-radius: 4px;
    cursor: pointer;

    &:hover {
    background-color: #4caf50;
    }
`;

const Label = styled.div`
    color: red;
    font-weight: bold;
    margin-bottom: 10px;
`;

const IconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(74, 125, 255, 0.04);
    border-radius: 40px;
    width: 84px;
    height: 84px;
`;

const Title = styled.div`
    font-family: 'Poppins';
    font-style: normal;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    color: #FFFFFF;
`;

const SubTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1px;
    color: #7A7F9E;
`;


const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;


const SecurityWrapper = styled.div`
    background: #1C2A4C;
    padding: 14px 22px;
    text-align: left;
    color: #fff;
    border-radius: 8px;
    display: flex;
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.2px;
`;

const BlueButton = styled.div<{ isLoading: boolean }>`
  background: linear-gradient(90.07deg, #3999F9 29.06%, #4A7DFF 96.96%);
  border-radius: 8px;
  padding: 12px;
  text-align: center;
  font-family: 'Inter';
  font-style: normal;
  font-weight: 600;
  font-size: 16.2526px;
  line-height: 20px;
  text-align: center;
  letter-spacing: 0.101579px;
  color: #fff;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
  cursor: ${({ isLoading }) => (isLoading ? 'not-allowed' : 'pointer')};
  opacity: ${({ isLoading }) => (isLoading ? '0.7' : '1')};
  pointer-events: ${({ isLoading }) => (isLoading ? 'none' : 'auto')};

`;

const Tile = styled.div`
    background: #141624;
    border-radius: 16px;
    padding: 12px 16px;
    background: #141624;
    border-radius: 16px;
`;

const WhiteTileTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #FFFFFF;
`;

const GreyTileTitle = styled.div`
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.1px;
    color: #7A7F9E;
`;

const WhiteParagraph = styled.p`
    color: white;
    margin: 0;
`;

// Define the App component
const MudrexOffRampPageMain: React.FC = () => {
    const [amount, setAmount] = useState('');
    const [currency, setCurrency] = useState('');
    const [txComplete, setTxComplete] = useState(false);
    
    const [mudrexUser, setMudrexUser] = useState(null as any);
    const [allowWithdraw, setAllowWithdraw] = useState(false);
    const [conversionRate, setConversionRate] = useState(-1);
    const [
        sendingOffRampRequest,
        setSendingOffRampRequest] = useState(false);
    const navigate: any = useNavigate();

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const gc_balance = searchParams.get("gc_balance");
    const selectedAccount = mudrexUser?.bank_accounts[0] ? mudrexUser?.bank_accounts[0]: {};
    const [txDone, setTxDone] = useState(false);
    console.log('selectedAccount', selectedAccount, mudrexUser);
    


    useEffect(() => {
        (window as any).callbackBackPressed  = () => {
            // unregister the callback
            goBack();
        };
    }, [])
    
    const handleKycClick = () => {
        //
        if(mudrexUser.kyc_status != 'Verified'){
            // send to mudrex page
            navigate(`/wallet-host/mudrex-off-ramp/`);
        }
    };
    
    const getSetMudrexUserInfo = async () => {
        let mudrexUserInfo = await getCreateMudrexUserInfo();
        console.log('mudrexUserInfo', mudrexUserInfo);
        if(!mudrexUserInfo.bank_accounts){
            setMudrexUser({...mudrexUserInfo, bank_accounts:[]});
            return;
        }
        setMudrexUser({...mudrexUserInfo});
    }

    const getSetConversionRate = async () => {
        let crypto = 'GC';
        let fiat = 'INR';
        let conversionRate = await getConversionRate({
            crypto,
            fiat,
            opType:'sell'
        });
        console.log('conversionRate', conversionRate);
        setConversionRate(conversionRate);
    }
    
    useEffect(()=>{
        getSetMudrexUserInfo();
        getSetConversionRate();
        
    }, []);

    const goBack = () => {
        navigate(-1);
    };

    useEffect(() => {
        if(mudrexUser && mudrexUser.kyc_status === 'Verified' && mudrexUser.bank_accounts.length > 0){
            setAllowWithdraw(true);
        }
    }, [mudrexUser]);

    const handleInputChange = (e:any)=>{
        setAmount(e.target.value);
    }

    const handleConfirmClick = async (e:any) => {
        setSendingOffRampRequest(true);
        eventTracker('offramp_initiated', {});
        let crypto = 'GC';
        let fiat = 'INR';
        //if amout is less than 600, show toast
        if(Number(amount) < 600){
            toast.info('Amount should be greater than 600')
            setSendingOffRampRequest(false);
            return;
        }
        if(Number(amount)>  Number(gc_balance)){
            toast.info('Amount should be less than balance')
            setSendingOffRampRequest(false);
            return;
        }
        let offRampResponse = await sendOffRampRequest({
            crypto,
            fiat,
            bankId: selectedAccount.bank_id,
            amount
        });
        if(offRampResponse){
            toast.success('Success')
            setTxComplete(true);
            setSendingOffRampRequest(false);
            return;
        }
        /* setTimeout(() => {
         *     setSendingOffRampRequest(false);
         * }, 1000); */
        toast.error('Failed')
        eventTracker('offramp_success', {});
        setSendingOffRampRequest(false);
    }

    if(!mudrexUser){
        return (
            <PageWrapper><Loader /></PageWrapper>
        );
    }
    
    let kycButtonEnabled = false;
    if(mudrexUser.kyc_status === 'Verified'){
        kycButtonEnabled = true;
    }
    
    let convertedAmountString = '';
    if(amount != '' && conversionRate != -1){
        let numberAmount = Number(amount);
        let convertedAmount:any = numberAmount * conversionRate;
        // convert to two decimal floor
        convertedAmount = convertedAmount.toFixed(2);
        convertedAmountString = `You will get ${convertedAmount} INR`
    }
    
    return (
        <Container>
          <div onClick={() => goBack()} style={{position: 'absolute', top: 0, left: 20}}>
            <img style={{position: 'absolute', top: 20}} src={back} alt='back arrow' className='hover'/>
            <BackTitle className='hover' style={{display: 'flex', justifyContent: 'center', marginTop: 16, marginLeft: 30}}>
              Withdraw
            </BackTitle>        
          </div>
          
          {!allowWithdraw ? <>
            <FlexContainer>
              <IconWrapper>
                <img src={withdraw_blue} />
              </IconWrapper>
              <Title style={{marginTop: 54}}>Verify your identity</Title>
              <SubTitle style={{marginTop: 16}}>You will need to go through a KYC process in order to withdraw your money.</SubTitle>
              
            </FlexContainer>
            <div style={{display: 'flex', flexDirection: 'column'}}>
              <SecurityWrapper>
                <img src={blue_tick} />
                <span style={{marginLeft: 22}}>This process is secured by 256-bit security protocols.</span>
              </SecurityWrapper>
              <BlueButton isLoading={false} className='hover' onClick={handleKycClick} style={{marginTop: 16}}>Verify Identity</BlueButton>
            </div>
          </>
          :
           <>
             <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%'}}>
               <div style={{display: 'flex', flexDirection: 'column'}}>
                 <Tile style={{display: 'flex', marginTop: 50}}>
                   <img src={bank_blue} />
                   <div style={{display: 'flex', flexDirection: 'column', marginLeft: 16}}>
                     <GreyTileTitle style={{margin: 0}}>Bank Account</GreyTileTitle>
                     <WhiteTileTitle style={{margin: 0}}>.... {selectedAccount.account_number ? selectedAccount.account_number.substring(selectedAccount.account_number.length - 4) : 'XXXX'}</WhiteTileTitle>
                   </div>
                 </Tile>
                 <Tile style={{marginTop: 8}}>
                   <GreyTileTitle>Token to withdraw</GreyTileTitle>
                   <div style={{display: 'flex', marginTop: 12, justifyContent: 'space-between'}}>
                     <div style={{display: 'flex'}}>
                       <img src={glip_icon_blue} />
                       <div style={{display: 'flex', flexDirection: 'column', marginLeft: 16}}>
                         <WhiteTileTitle style={{margin: 0}}>BTX Coin</WhiteTileTitle>
                         <GreyTileTitle style={{margin: 0}}>Your balance: {gc_balance} BTX</GreyTileTitle>
                       </div>
                     </div>
                   </div>
                 </Tile>
                 <Tile style={{display: 'flex', marginTop: 8}}>
                   <input
                       type="number"
                       value={amount}
                       placeholder='Enter token amount to withdraw' style={{
                           fontSize: 16, background: 'transparent',
                           color: 'white',
                           border: 'none', width: '100%'}} onChange={handleInputChange}
                   />
                 </Tile>
                 <WhiteTileTitle style={{display: 'flex', marginTop: 18, marginLeft: 12}}>{convertedAmountString}</WhiteTileTitle>
               </div>
               <div>
                 <Label>
                   <span role="img" aria-label="Important">*</span> Important Notice:
                 </Label>
                 <Label>
                   1) Bank transfers are processed between 9 AM to 9 PM.
                 </Label>
                 <Label>
                   2) The transfer may take approximately 2-3 hours to complete.
                 </Label>
                 <Label>
                   Please plan your transfers accordingly.
                 </Label>
                 {txComplete && (
                     <BlueButton
                         onClick={(e:any) => {navigate(`/wallet-host/`);}}
                         isLoading={sendingOffRampRequest}>
                       Transaction Done. Go Back.
                     </BlueButton>
                 )}
                 {!txComplete && (
                     <BlueButton
                         onClick={(e:any) => {handleConfirmClick(e);}}
                         isLoading={sendingOffRampRequest}>
                       {sendingOffRampRequest ? 'Loading...' : 'Confirm'}
                     </BlueButton>
                 )}
               </div>
             </div>
           </>}
        </Container>
);
};

export default MudrexOffRampPageMain;


